/**
 * Utility function to safely create iframe URLs
 * In React, we don't need Angular's DomSanitizer, but we can use this
 * to ensure URLs are properly formatted for iframe src attributes
 */
export const createSafeUrl = (url: string): string => {
  // For Google Maps embed URLs, we can directly use them
  // React will handle them safely
  return url;
};

